import React, { useContext } from "react";
import { Container, Navbar, Nav, Dropdown } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { UserContext } from "../../../utils/ProtectedRoute";

const NavBar = ({ setHandleNavbar, handleNavbar }) => {
  const { userData } = useContext(UserContext);

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100 flex-row-reverse">
          <div className="d-flex align-items-center ">
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  {/* <Image
                    src="/"
                    className="user-avatar md-avatar rounded-circle"
                  /> */}
                  <FontAwesomeIcon icon={faUserCircle} size="2x" />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <div className="mb-0 font-small fw-bold">
                      {userData?.nama}
                    </div>
                    <div className="mb-0 font-small">{userData?.role}</div>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                <Dropdown.Item className="fw-bold" href="/profile">
                  <FontAwesomeIcon icon={faUserCircle} className="me-2" />
                  My Profile
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default NavBar;
